const localWindow = window || {};

export default localWindow;
